import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { PlanoModel, ResponsePaginated } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlanoService {
  context = '/planos';
  constructor(private apiService: ApiService) {}

  add(plano: PlanoModel): Observable<PlanoModel> {
    return this.apiService.post(`${this.context}`, { plano }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getAll(): Observable<PlanoModel[]> {
    return this.apiService.get(`${this.context}`);
  }

  getMaisAderidos(): Observable<PlanoModel[]> {
    return this.apiService.get('/planos/topPlanoComMaisInscricoes');
  }

  getById(id: string): Observable<PlanoModel> {
    return this.apiService.get(`${this.context}/${id}`);
  }

  update(plano: PlanoModel): Observable<PlanoModel> {
    const { id } = plano;
    return this.apiService.put(`${this.context}/${id}`, plano).pipe(
      map((data) => {
        return data;
      })
    );
  }

  delete(id: string) {
    return this.apiService.delete(`${this.context}/${id}`).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
